import { withRouter } from "react-router";
import { graphql } from "@apollo/client/react/hoc";
import flowRight from "lodash/flowRight";
import { connect } from "react-redux";
import gql from "graphql-tag";

import React from "react";

let Loading = require("./loading");

class InvoiceEdit extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            error: false,
            insertLoading: false,
            isInserting: false
        };
    }

    render() {
        if (this.props.data.charge) {
            let charge = this.props.data.charge,
                detailButtonData = this.renderButtonData();
            return (
                <section id="edit-invoice">
                    <header>
                        <h3>Extra Invoice Info</h3>
                    </header>
                    <p>
                        Invoice:{" "}
                        <a
                            href={`/${this.props.username}/settings/invoices/${charge.stripeId}/`}
                            target="_blank"
                        >
                            {charge.stripeId}
                        </a>
                    </p>
                    <p>
                        This information shows on your invoice, some people need
                        this for tax purposes.
                        <br /> (VAT, Address, Job Number, Etc).
                    </p>
                    <form
                        action="./"
                        onSubmit={this.saveReceiptInfo.bind(this)}
                    >
                        <label className={this.state.error ? "error" : ""}>
                            <textarea
                                className={this.state.error ? "error" : ""}
                                autoFocus={true}
                                defaultValue={charge.receiptInfo}
                                ref={receiptInfo => {
                                    this.receiptInfo = receiptInfo;
                                }}
                            />
                            {this.state.error
                                ? "There was an error saving your receipt. Please try again."
                                : ""}
                        </label>
                        <button
                            style={{ marginTop: "20px" }}
                            className={detailButtonData.class.join(" ")}
                            type="submit"
                        >
                            <span>Update extra invoice info</span>
                        </button>
                        <div style={{ textAlign: "center" }}>
                            <a href="../../">View all invoices</a>
                        </div>
                    </form>
                </section>
            );
        } else {
            return <Loading />;
        }
    }

    renderButtonData() {
        let buttonData = {
            class: ["button", "full-width", "button-process"]
        };

        if (this.state.insertLoading) {
            buttonData.class.push("processing blue");
        } else {
            buttonData.class.push("black");
        }

        return buttonData;
    }

    saveReceiptInfo(e) {
        e.preventDefault();

        this.setState({ insertLoading: true });

        const paypalChargeId = this.props.chargeId;
        const stripeChargeId = this.props.data.charge.stripeId;

        // if a charge id is present for paypal use that first otherwise default to stripe
        const chargeId = paypalChargeId ? paypalChargeId : stripeChargeId;

        this.props
            .mutate({
                variables: {
                    chargeId: chargeId,
                    receiptInfo: this.receiptInfo.value
                }
            })
            .then(({ data }) => {
                this.props.data.refetch();
                this.setState({ insertLoading: false });
            })
            .catch(error => {
                this.props.data.refetch();
                this.setState({
                    error: true,
                    insertLoading: false
                });
            });
    }
}

const receiptInfoQuery = gql`
    query getReceiptInfo($chargeId: ID!) {
        charge(stripeOrPaypalId: $chargeId) {
            stripeId
            receiptInfo
        }
    }
`;

const updateReceiptInfo = gql`
    mutation saveReceiptInfo($chargeId: ID!, $receiptInfo: String!) {
        updateCharge(stripeOrPaypalId: $chargeId, receiptInfo: $receiptInfo) {
            ok
        }
    }
`;

function mapStateToProps(state, ownProps) {
    let creator, userId, username;
    if (state.creator.keys && state.creator.keys[0]) {
        creator = state.creator[state.creator.keys[0]];
        userId = creator.id;
        username = creator.username;
    } else if (state.user) {
        let user = state.user;
        userId = user.id;
        username = user.username;
    }

    if (global._pageConfig && global._pageConfig.billing_user_id) {
        userId = global._pageConfig.billing_user_id;
    }

    let { match } = ownProps;
    let { chargeId } = match.params;

    return { userId, creator, chargeId, username };
}

const InvoiceDetailQuery = flowRight([
    graphql(receiptInfoQuery, {
        options: ({ chargeId }) => ({
            variables: { chargeId }
        })
    }),
    graphql(updateReceiptInfo)
])(InvoiceEdit);

const ConnectedInvoiceDetail = withRouter(
    connect(mapStateToProps, {})(InvoiceDetailQuery)
);

export default ConnectedInvoiceDetail;
